export enum WEIGHTS {
  regular = 400,
  medium = 500,
  semibold = 600,
  bold = 700,
  extrabold = 800,
}
